import React, { ButtonHTMLAttributes, FC, ReactNode } from 'react'

import { ButtonAdditionalContent, ButtonRoot, ButtonText } from './Button.styled'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'dark' | 'primary' | 'white' | 'grey'
  disabled?: boolean
  secondaryContent?: ReactNode
  size?: 'medium' | 'small'
  variant?: 'full' | 'outlined'
  width?: 'full' | 'auto'
}

// This function helps us translate weird button inputs from the CMS to something tangible.
export const parseButtonColor = (buttonColor?: ButtonProps['color'] | 'default'): ButtonProps['color'] => (
  buttonColor === 'default'
    ? 'primary'
    : buttonColor || 'primary'
)

export const Button: FC<ButtonProps> = (
  {
    children,
    color = 'primary',
    disabled = false,
    secondaryContent,
    size = 'medium',
    type = 'button',
    variant = 'full',
    width = 'full',
    ...props
  }: ButtonProps,
) => (
  <ButtonRoot
    color={color}
    disabled={disabled}
    secondaryContent={secondaryContent}
    size={size}
    type={type}
    variant={variant}
    width={width}
    {...props}
  >
    <>
      <ButtonText>{children}</ButtonText>
      {secondaryContent && <ButtonAdditionalContent>{secondaryContent}</ButtonAdditionalContent>}
    </>
  </ButtonRoot>
)
